
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import ArticleItem  from "components/ArticleItem";

import { withRouterJim } from "router/withRouterJim";

//--- CONTEXT API -----------
import { useStore, useDispatch, StoreContext } from "store/StoreProvider";
import {types, storeReducer} from "store/StoreReducer"

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class CursoMain extends React.Component {
  state = {

    modalImagen: false,
        
    form: Object.assign({}, initialForm),
    data: [],/* lista  */
    
  };

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    
    this.cargar_materia();

    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');
  
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,
    "id_cate": 99,
    "sigla": "SIM-101",
    "nombre": "SEGURIDAD INDUSTRIAL Y MEDIO AMBIENTE",
    "fecha_ini": null,
    "fecha_fin": null,
    "visible_sn": 0,
    "id_grupo": 1,
    "id_siseval": 0,
    "foto": "",
    "resumen": "",
    "estado": 0
   */
  cargar_materia=()=>{
    /*let id_est = this.props.store.user.id_est;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;

    let param = { 
      id_est: id_est,
      id_peri: id_peri,
    }
    
    axios2.post("cursos_sel_listado_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.length>0){ 
            this.setState({data: res.data});
        }else{
            NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });*/
  }
  //-----------------------------------------
 
  //------------------------------
  render() {
      const materia = this.props.store.materia;
      
    return(
      <div>
        {/* ---   --- */}
        { 
          //JSON.stringify(this.state.form)
          //JSON.stringify(materia)
        }
        <div className="container">

          <div className="row">
            <div className="col-md-12">
              <div className="card p-3">
                <div className="box-header with-border">
                  <h5>Sigla: { materia.sigla }  </h5>
                </div>

                {/*<!-- /.box-header -->*/}
                <div className="box-body">
                  <div className="row">
                    <div className="col-md-12">
                      {/*<!-----------Contenido------------->*/}
                      <div className="tiny_personalizado" style={{overflow: 'hidden'}}>


                        <div id="imagenHomeContainer" style={{textAlign: 'center'}}>
                          <img  src={ process.env.REACT_APP_AFILES + materia.foto_path } 
                                alt="" style={{width: '100%'}}/>
                        </div>

                        <h2 style={{textAlign: 'center' }}><span>¡Bienvenido!</span></h2>
                      </div>
                      {/*<!----------Fin Contenido---------------->*/}

                    </div> {/*<!-- col-md-12-->*/}
                  </div> {/*<!-- /.row -->*/}
                </div> {/*<!-- /.box-body -->*/}
              </div> {/*<!-- /.box -->*/}
            </div> {/*<!-- /.col -->*/}
          </div>

        </div>
        

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(CursoMain);